// import { Subject } from 'rxjs/Subject';
import {Subject} from "rxjs/Rx";
import {PanierStore} from "@common/store/panier.store";
import {AsiTable, AsiTableData} from "@asi-ngtools/lib";
import {
  CommandeMaterielDto,
  CorrespondantDetailsDto,
  ICommandeMaterielWebServiceClient,
  LigneCommandeMaterielDto
} from "@resources/resources";
import {ActivatedRoute, Router} from "@angular/router";
import {Component, ViewChild} from "@angular/core";
import {TranslateService} from "@ngx-translate/core";
import {ArianeElement, ArianeStore, ModalService, WindowService, CorrespondantStore} from "@digicerba/common";

@Component({
  selector: 'gestion-panier',
  templateUrl: './gestion.panier.component.html',
  host: { 'class': 'page' }
})
export class GestionPanierComponent {

  @ViewChild('cmPanierDataTable') ligneCommandeTable: AsiTable<LigneCommandeMaterielDto>;
  asiTableData: AsiTableData<LigneCommandeMaterielDto> = new AsiTableData<LigneCommandeMaterielDto>();
  correspondantDetails: CorrespondantDetailsDto = null;
  etatPanier: string = "";
  numeroCommande: number = 0;

  commentaire: string;
  commentaireChanged: Subject<any> = new Subject<any>();

  constructor(private arianeStore: ArianeStore, private translateService: TranslateService,
              private activatedRoute: ActivatedRoute, private modalService: ModalService,
              private commandeMaterielWebService: ICommandeMaterielWebServiceClient, private router: Router,
              private panierStore: PanierStore, private correspondantStore: CorrespondantStore, private windowService: WindowService) {

    this.initArianne();

    this.commentaireChanged
      .debounceTime(500) // wait 1 sec after the last event before emitting last event
      .distinctUntilChanged() // only emit if value is different from previous value
      .subscribe(model => {
        this.commentaire = model;

        // Call your function which calls API or do anything you would like do after a lag of 1 sec
        this.commandeMaterielWebService.saveComment(this.numeroCommande, this.commentaire);
      });

  }

  private initArianne() {
    let arianeElements: Array<ArianeElement>;
    arianeElements = [
      {
        libelle: "ARIANNE.module",
        route: "/"
      },
      {
        libelle: "ARIANNE.COMMANDE.panier",
        route: "/panier"
      }
    ];

    this.arianeStore.updateElements(arianeElements);
  }

  ngOnInit() {
    this.correspondantDetails = this.activatedRoute.snapshot.data['panier'];
    this.panierStore.resetAffichageRecap();
  }


  isValideCharacter(caractere :KeyboardEvent){
    switch (caractere.key){
      case ";" : return false;
      case "\"" :return false;
      case "'" : return this.commentaire[this.commentaire.length -1 ] != "'";
      default : return true;
    }
  }


  ngAfterContentInit() {
    // TODO ce truc doit être remplacé par une methode et (onRequestData)="refreshTable($event)" dans le tableau
    // TODO event est alors AsiTableRequest
    this.panierStore.getPanier().subscribe(panier => {
      console.log("Update affichage panier...");
      if (!panier) {
        panier = new CommandeMaterielDto();
      }
      if (!panier.lignes) {
        panier.lignes = [];
      }
      this.asiTableData.results = panier.lignes;
      this.ligneCommandeTable.updateData(this.asiTableData);
      this.etatPanier = panier.etat;
      this.numeroCommande = panier.id;
      this.commentaire = panier.commentaire;
    });
    this.panierStore.onPanierUpdate().subscribe(panier => {
      console.log("Update affichage panier...");
      if (!panier) {
        panier = new CommandeMaterielDto();
      }
      if (!panier.lignes) {
        panier.lignes = [];
      }
      this.etatPanier = panier.etat;
      this.asiTableData.results = panier.lignes;
      this.numeroCommande = panier.id;
      this.commentaire = panier.commentaire;
    });
  }

  getNumeroCommande() {
    return this.numeroCommande;
  }

  isPanier() {
    return this.etatPanier != ""
      && this.etatPanier != 'VALIDEE'
      && this.etatPanier != 'TERMINEE';
  }

  isRecap() {
    return this.panierStore.isAffichargeRecap() || this.etatPanier == 'VALIDEE';
  }

  isEnCoursValidation() {
    return this.etatPanier == 'EN_COURS_VALIDATION';
  }

  isValidee() {
    return this.etatPanier == 'VALIDEE';
  }

  countPanierArticles() {
    return this.panierStore.countPanierArticles();
  }

  isArticleActive(ligne: LigneCommandeMaterielDto) {
    return ligne.article.quota > 0 && ligne.article.actif;
  }

  getArticleQuota(article) {
    if (!article.actif) {
      return 0;
    }
    return article.quota;
  }

  gotoCategories() {
    console.log("Return to Categories");
    this.router.navigate(['cerba/categories']);
  }

  validateCommande() {
    console.log("Validation de la commande...");
    this.panierStore.validateCommande();
  }

  updateQuantite(id, quantite) {
    console.log("Update quantité...");
    this.panierStore.updateQuantite(id, quantite);
  }


  deleteLigneCommande(id) {
    this.modalService.openConfirmDialog("MODAL.DELETE_LIGNE_COMMANDE.title", "MODAL.DELETE_LIGNE_COMMANDE.message",
      "MODAL.DELETE_LIGNE_COMMANDE.confirm", "MODAL.DELETE_LIGNE_COMMANDE.cancel").onDialogClose().subscribe(() => {
        console.log("Suppression d'un article de la commande:" + id);
        this.panierStore.deleteItem(id);
    });
  }

  openPrint() {
    this.windowService.openPrint();
  }

  saveComment() {
    this.commentaireChanged.next(this.commentaire);
  }

  isEmpty() {
    let result = false;
    this.asiTableData.results.forEach((l: LigneCommandeMaterielDto) => {
      if (l.article.actif) {
        result = result || l.article.actif;
      }
    })
    return !result;
  }
}




// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-commande-materiel/digicerba-commande-materiel-web/src/angular/cerba/src/app/pages/cerba/pages/gestion-panier/gestion.panier.component.ts